<template>
    <div class="navbar-user">
        <!-- Dropdown -->

        <b-dropdown variant="link" right no-caret>
            <template slot="button-content">
                <avatar v-if="user.avatar" :src="user.avatar.preview" size="avatar-sm" type="circle"></avatar>
                <avatar v-else :src="null" size="avatar-sm" type="circle"></avatar>
            </template>
            <div class="row">
                <div class="col-5" v-if="false">
                    <permission-check resource="service" create v-if="$loadModule('services')">
                        <b-dropdown-item @click="$router.push({name:'company.services'})" href="#">{{$t('Services')}}</b-dropdown-item>
                    </permission-check>
                    <permission-check resource="documents" create v-if="$loadModule('documents')">
                        <b-dropdown-item @click="$router.push({name:'company.documents'})" href="#">{{$t('Documents')}}</b-dropdown-item>
                    </permission-check>

                    <permission-check resource="sources" create v-if="$loadModule('customers')">
                        <b-dropdown-item @click="$router.push({name:'company.sources'})" href="#">{{$t('Sources')}}</b-dropdown-item>
                    </permission-check>

                    <div v-if="$loadModule('treatments')">
                        <permission-check resource="specialty" create>
                            <b-dropdown-item
                                @click="$router.push({name:'company.specialty'})"
                                href="#"
                            >{{$t('Specialties')}}</b-dropdown-item>
                        </permission-check>
                        <permission-check resource="icd" create>
                            <b-dropdown-item @click="$router.push({name:'company.icd'})" href="#">{{$t('ICD-10')}}</b-dropdown-item>
                        </permission-check>
                        <permission-check resource="cdb" create>
                            <b-dropdown-item @click="$router.push({name:'company.cdb'})" href="#">{{$t('Complaints')}}</b-dropdown-item>
                        </permission-check>
                        <permission-check resource="odb" create>
                            <b-dropdown-item @click="$router.push({name:'company.odb'})" href="#">{{$t('Objectively')}}</b-dropdown-item>
                        </permission-check>
                        <permission-check resource="manipulations" create>
                            <b-dropdown-item
                                @click="$router.push({name:'company.manipulations'})"
                                href="#"
                            >{{$t('Manipulations')}}</b-dropdown-item>
                        </permission-check>
                        <permission-check resource="presets" create>
                            <b-dropdown-item @click="$router.push({name:'company.presets'})" href="#">{{$t('Presets')}}</b-dropdown-item>
                        </permission-check>
                        <permission-check resource="timeline" view>
                            <b-dropdown-item
                                @click="$router.push({name:'company.userActivities'})"
                                href="#"
                            >{{$t('User Activities')}}</b-dropdown-item>
                        </permission-check>
                        <permission-check resource="tags" view>
                            <b-dropdown-item @click="$router.push({name:'company.tags'})" href="#">{{$t('Tags')}}</b-dropdown-item>
                        </permission-check>
                        <permission-check resource="work-place" create>
                            <b-dropdown-item
                                @click="$router.push({name:'company.work-places'})"
                                href="#"
                            >{{$t('Workplaces')}}</b-dropdown-item>
                        </permission-check>
                        <permission-check resource="roles" create>
                            <b-dropdown-item @click="$router.push({name:'company.roles'})" href="#">{{$t('Roles')}}</b-dropdown-item>
                        </permission-check>
                        <b-dropdown-item @click="$router.push({name:'company.trash'})" href="#">{{$t('Trash')}}</b-dropdown-item>
                    </div>
                    <!-- <b-dropdown-divider></b-dropdown-divider> -->
                </div>
                <div class="col-7">
                    <b-dropdown-item @click="$router.push({name:'profile.me'})" href="#">{{$t('My profile')}}</b-dropdown-item>

                    <permission-check resource="invoices" view v-if="$loadModule('billing')">
                        <b-dropdown-item @click="$router.push({name:'company.payments'})" href="#">{{$t('Payments')}}</b-dropdown-item>
                    </permission-check>

                    <permission-check resource="sources" create v-if="$loadModule('customers')">
                        <b-dropdown-item
                            @click="$router.push({name:'company.communications'})"
                            href="#"
                        >{{$t('Communications')}}</b-dropdown-item>
                    </permission-check>

                    <permission-check resource="media" view>
                        <b-dropdown-item
                            @click="$router.push({name:'company.media'})"
                            href="#"
                        >{{$t('Media manager')}}</b-dropdown-item>
                    </permission-check>
                    <!-- <permission-check resource="dispatcher" create>
                        <b-dropdown-item @click="$router.push({name:'company.dispatch'})" href="#">{{$t('Dispatch')}}</b-dropdown-item>
                    </permission-check>-->
                    <b-dropdown-item @click="$router.push({name:'settings'})" href="#">{{$t('Settings')}}</b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="$router.push({name:'logout'})" href="#">{{$t('Logout')}}</b-dropdown-item>
                    <permission-check resource="force-logout" create>
                        <b-dropdown-item @click="forceLogout" href="#">
                            <span class="fe fe-alert-triangle text-danger"></span>
                            {{$t('Emergency logout')}}
                        </b-dropdown-item>
                    </permission-check>
                </div>
            </div>
        </b-dropdown>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Avatar from '@/components/Avatar.vue';
import app from '@/feathers-client.js'

export default {
    components: {
        Avatar
    },
    computed: {
        ...mapState('auth', [
            'user'
        ]),
        // ...mapGetters('users', {
        //     getUserById: 'get'
        // }),
    },
    created() {
        this.getUser(this.user._id);
        app.service('force-logout').on('created', data => {
            this.$router.push({ name: 'logout', query: { emergency: true } })
        })
    },
    methods: {
        ...mapActions('users', {
            getUser: 'get',
        }),

        ...mapActions('force-logout', { createLogout: 'create' }),

        forceLogout() {
            if (window.confirm(this.$t('Are you sure you want to logout all of your team?'))) {
                this.createLogout({})
            }
        }
    },

}
</script>
